/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { ValidatedInput } from '@bingads-webui-react/validation-controls';
import { DefaultButton } from '@bingads-webui-react/fabric-control';

export class UrlEditor extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isValid: true,
    };
  }

  onValidate = (result) => {
    this.setState({
      isValid: result.isValid,
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="image-url-container">
          <ValidatedInput
            className="image-url-input"
            value={this.props.url}
            onChange={this.props.onUrlChanged}
            validationProps={{
              schema: {
                properties: {
                  Text: {
                    type: 'string',
                    maxLength: 1024,
                    minLength: 1,
                  },
                },
              },
              field: 'Text',
              i18n: this.props.i18n,
              onValidate: this.onValidate,
            }}
            id="image-url-field"
            ariaLabel={this.props.i18n.getString('ImageExperience_Edit_Url')}
            placeholder={this.props.i18n.getString('ImageExperience_Edit_Url')}
          />
          <DefaultButton
            onClick={this.props.onSubmit}
            disabled={!this.state.isValid}
            text={this.props.i18n.getString('ImageExperience_Get_Video_Label')}
            className="image-url-button"
          />
        </div>
      </React.Fragment>
    );
  }
}

UrlEditor.propTypes = {
  url: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onUrlChanged: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};


UrlEditor.defaultProps = {
  url: '',
};
